import React from "react";
import "./AppointmentSection.css";

const AppointmentSection = () => {
  return (
    <section className="cis-appointment" id="appointment" aria-label="Online appointments">
      <div className="cis-appointment__container">
        <div className="cis-appointment__grid">
          {/* Left side - Image */}
          <div className="cis-appointment__media">
            <img
              className="cis-appointment__image"
              src="/fa1.jpg"
              alt="Business consultation meeting"
              loading="lazy"
            />
          </div>

          {/* Right side - Content */}
          <div className="cis-appointment__content">
            <h2 className="cis-appointment__title">
              Online <span>Appointments</span>
            </h2>
            <div className="cis-appointment__underline"></div>

            <div className="cis-appointment__services">
              {/* Service 1 */}
              <div className="cis-appointment__service">
                <h3 className="cis-appointment__serviceTitle">
                  Non Profit Business Strategy Consultation
                </h3>
                <div className="cis-appointment__serviceMeta">
                  <span className="cis-appointment__duration">1 hr</span>
                  <span className="cis-appointment__divider">•</span>
                  <span className="cis-appointment__pricing">Contact for pricing</span>
                </div>
                <p className="cis-appointment__serviceDesc">
                  A comprehensive session focusing on strategic planning and business growth.
                </p>
              </div>

              {/* Service 2 */}
              <div className="cis-appointment__service">
                <h3 className="cis-appointment__serviceTitle">
                  Father Engagement Program Development
                </h3>
                <div className="cis-appointment__serviceMeta">
                  <span className="cis-appointment__duration">1 hr</span>
                  <span className="cis-appointment__divider">•</span>
                  <span className="cis-appointment__pricing">Contact for pricing</span>
                </div>
                <p className="cis-appointment__serviceDesc">
                  We help agencies build effective father engagement programs that strengthen families and improve outcomes. Using proven strategies and nearly two decades of experience, we help organizations meaningfully engage fathers
                </p>
              </div>
            </div>

            {/* Request Consultation Button */}
            <a className="cis-appointment__btn" href="/contact">
              Request consultation <span className="cis-appointment__btnArrow">→</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AppointmentSection;